const CUSTOMER_GROUP = 'Customer';
const CUSTOMER_QUOTE_VIEWER_GROUP = 'Customer Quote Viewer';
const CUSTOMER_QUOTE_APPROVER_GROUP = 'Customer Quote Approver';
const CUSTOMER_INVOICE_VIEWER_GROUP = 'Customer Invoice Viewer';
const CUSTOMER_USER_MANAGER = 'Customer User Manager';
const REPORT_VIEWER_GROUP = 'Report Viewer';
const CUSTOMER_PRIORITY_EDITOR_GROUP = 'Customer Priority Editor';
const SERVICECENTER_GROUP = 'Service Center';
const SERVICEPROVIDER_GROUP = 'Service Provider';
const SERVICEPROVIDER_CONTROLLER_GROUP = 'Service Provider Controller';
const SERVICEPROVIDER_FINANCIAL_GROUP = 'Service Provider Financial';
const SERVICEPROVIDER_MOBILE_GROUP = 'Service Provider Mobile';
const SPM_USER_MANAGER = 'SPM User Manager';
const INTERNAL_SERVICEPROVIDER_GROUP = 'Internal Service Provider';
const SUPPORT_USER_GROUP = 'Support User';
const USER_MANAGEMENT_ADMINISTRATOR = 'User Management Administrator';
const ADMIN_PORTAL_GROUP = 'Admin Portal';

const CLAIM_CORPORATE_ACCESS = 'CorporateAccess';
const CLAIM_INDIVIDUAL_SITE_ACCESS = 'IndividualSiteAccess';
const CLAIM_SITE_TIER_LEVEL_ACCESS = 'SiteTierLevelAccess';
const CLAIM_QUOTE_APPROVAL_LIMIT = 'QuoteApprovalLimit';

export class UserAuth0GroupsModel {
  public static CUSTOMER_GROUP = CUSTOMER_GROUP;
  public static CUSTOMER_QUOTE_VIEWER_GROUP = CUSTOMER_QUOTE_VIEWER_GROUP;
  public static CUSTOMER_QUOTE_APPROVER_GROUP = CUSTOMER_QUOTE_APPROVER_GROUP;
  public static CUSTOMER_INVOICE_VIEWER_GROUP = CUSTOMER_INVOICE_VIEWER_GROUP;
  public static CUSTOMER_USER_MANAGER = CUSTOMER_USER_MANAGER;
  public static REPORT_VIEWER_GROUP = REPORT_VIEWER_GROUP;
  public static CUSTOMER_PRIORITY_EDITOR_GROUP = CUSTOMER_PRIORITY_EDITOR_GROUP;
  public static SERVICECENTER_GROUP = SERVICECENTER_GROUP;
  public static SERVICEPROVIDER_GROUP = SERVICEPROVIDER_GROUP;
  public static SERVICEPROVIDER_CONTROLLER_GROUP = SERVICEPROVIDER_CONTROLLER_GROUP;
  public static SERVICEPROVIDER_FINANCIAL_GROUP = SERVICEPROVIDER_FINANCIAL_GROUP;
  public static SERVICEPROVIDER_MOBILE_GROUP = SERVICEPROVIDER_MOBILE_GROUP;
  public static SPM_USER_MANAGER = SPM_USER_MANAGER;
  public static INTERNAL_SERVICEPROVIDER_GROUP = INTERNAL_SERVICEPROVIDER_GROUP;
  public static SUPPORT_USER_GROUP = SUPPORT_USER_GROUP;
  public static USER_MANAGEMENT_ADMINISTRATOR = USER_MANAGEMENT_ADMINISTRATOR;
  public static ADMIN_PORTAL_GROUP = ADMIN_PORTAL_GROUP;
}

export class UserClaimModel {
  public static CLAIM_CORPORATE_ACCESS = CLAIM_CORPORATE_ACCESS;
  public static CLAIM_INDIVIDUAL_SITE_ACCESS = CLAIM_INDIVIDUAL_SITE_ACCESS;
  public static CLAIM_SITE_TIER_LEVEL_ACCESS = CLAIM_SITE_TIER_LEVEL_ACCESS;
  public static CLAIM_QUOTE_APPROVAL_LIMIT = CLAIM_QUOTE_APPROVAL_LIMIT;
}
